import { createContext } from "react";

const CardsContext = createContext();

export default CardsContext;
